module.exports = __webpack_public_path__ + "media/src/assets/Images/FooterPDF-1be4ebe01b31338bec8360a5d2ce1e6e.jpg";